import {
  DEFAULT_TAG_SUGGESTIONS,
  findTag,
  nextTagColor,
  tagKey,
  uniqueTagNames,
} from "./tags";

const SUGGESTION_LIMIT = 8;
const FEW_TAGS = 5;

const timeOf = (value) => {
  const time = Date.parse(value ?? "");
  return Number.isNaN(time) ? -Infinity : time;
};

const byName = (a, b) =>
  a.name.localeCompare(b.name, "de", { sensitivity: "base" });

export const byRecentUse = (a, b) =>
  timeOf(b.last_used_at) - timeOf(a.last_used_at) ||
  (b.usage ?? 0) - (a.usage ?? 0) ||
  byName(a, b);

export const sortTagsByName = (tags = []) =>
  [...tags].sort((a, b) => byName(a, b) || `${a.id}`.localeCompare(`${b.id}`));

// The order does not depend on the selection, so chips never jump while tapping.
export const suggestTags = (
  groupTags = [],
  selectedNames = [],
  { limit = SUGGESTION_LIMIT } = {},
) => {
  const recent = [...groupTags].sort(byRecentUse).map((tag) => tag.name);
  const defaults =
    groupTags.length < FEW_TAGS
      ? DEFAULT_TAG_SUGGESTIONS.filter((name) => !findTag(groupTags, name))
      : [];
  const base = [...recent, ...defaults].slice(0, limit);
  const baseKeys = new Set(base.map(tagKey));
  const selected = uniqueTagNames(selectedNames);
  const selectedKeys = new Set(selected.map(tagKey));
  const extra = selected.filter((name) => !baseKeys.has(tagKey(name)));

  // New tags get their color on the server in the order they are sent.
  const colors = groupTags.map((tag) => tag.color);
  const predicted = new Map();
  for (const name of [...selected, ...base]) {
    if (findTag(groupTags, name) || predicted.has(tagKey(name))) continue;
    const color = nextTagColor(colors);
    colors.push(color);
    predicted.set(tagKey(name), color);
  }
  return [...base, ...extra].map((name) => {
    const existing = findTag(groupTags, name);
    return {
      name: existing?.name ?? name,
      color: existing?.color ?? predicted.get(tagKey(name)),
      selected: selectedKeys.has(tagKey(name)),
    };
  });
};
